import { Box, MenuItemProps } from '@mui/material';
import { useContext } from 'react';
import { NativeSelectContext } from './SelectContext';
export default function MenuItem({children,disabled,selected,divider,dense,sx,className, ...props}:MenuItemProps & {value?:any}) {
    const nativeSelect=useContext(NativeSelectContext);
    if(nativeSelect)return <option value={props.value} disabled={disabled}>{children}</option>;
    return <Box {...props as any} component="button" type="button" role={props.role || 'menuitem'} disabled={disabled}
        className={`dropdown-item d-flex align-items-center gap-2 ${selected ? 'active' : ''} ${divider ? 'border-bottom' : ''} ${className || ''}`} sx={sx}>{children}</Box>;
}
